import { withStyles, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  title: {
    fontSize: '32px',
    fontFamily: 'Roboto',
    marginBottom: '24px',
    fontWeight: '400',
    color: '#666666',
  },
  table: {
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  button: {
    border: '2px solid #4676E0',
    borderRadius: '0',
    color: '#4676E0',
    padding: '9px 16px',
    letterSpacing: '1px',
    '&:hover': {
      backgroundColor: 'rgba(63, 81, 181, 0.04)',
      border: '2px solid #4676E0',
    },
  },
  buttonIcon: {
    marginRight: '10px',
  },
}));

export const StyledTableCell = withStyles(() => ({
  body: {
    fontSize: 14,
    color: '#666666',
  },
}))(TableCell);

export default useStyles;
